import {
  CircularProgress,
  DialogContent,
  Grid,
  Typography,
  Button,
  Box,
  Dialog,
} from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "../../../components/MDBox/index";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIos from "@mui/icons-material/ArrowBackIos";
import { getBillDetailsById } from "../../../services/invoiceService";
import TransactionHistory from "./TransactionHistory";
import AddPayment from "./AddPayment";
import axiosInstance from "../../../axios";

const BillDetails = () => {
  const navigate = useNavigate();
  const [responsedata, setResponseData] = useState(null);
  const [open, setOpen] = useState(false);
  const [openPayment, setOpenPayment] = useState(false);

  console.log("1-->", window.location.href);
  const ID = window.location.href.split("billDetails")[1].split("/")[1];
  console.log("ID", ID);
  // const getData = async () => {
  //   let response = await getBillDetailsById(ID);
  //   console.log( "response", response?.response?.data?.data);
  //   setResponseData(response?.response?.data?.data[0]);
  // };

  const getData = async () => {
    // let response = await getBillDetailsById(ID);
    //console.log("payload>>", ID);
    // console.time("API call");
    // log start time
    const start = performance.now();

    let criteria = { criteria: { _id: ID }, limit: 10, offset: 0 };
    console.log("criteria>>", criteria);
    const response = await axiosInstance.post(`/bill/list`, criteria);
    console.log("responseById: ", response);
    // console.timeEnd("API call");
    // log end time
    const end = performance.now();

    // timing breakdown
    console.log("⏱️ API call total time:", (end - start).toFixed(2), "ms");
    // agar browser timing details available hain
    if (response && response.request && response.request.responseURL) {
      const entries = performance.getEntriesByName(
        response.request.responseURL
      );
      if (entries.length > 0) {
        const timing = entries[0];
        console.log("🔍 Timing breakdown:", {
          dns: timing.domainLookupEnd - timing.domainLookupStart,
          tcp: timing.connectEnd - timing.connectStart,
          ssl:
            timing.secureConnectionStart > 0
              ? timing.connectEnd - timing.secureConnectionStart
              : 0,
          ttfb: timing.responseStart - timing.requestStart,
          download: timing.responseEnd - timing.responseStart,
          total: timing.duration,
        });
      }
    }
    //  return response;
    //console.log("response", response?.data?.data);
    setResponseData(response?.data?.data[0]);
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleOpenPayment = () => setOpenPayment(true);
  const handleClosePayment = () => setOpenPayment(false);

  useEffect(() => {
    if (ID) {
      console.log("call getdata")
      getData();
    }
  }, [ID]);

  const handleBack = () => {
    navigate(-1);
  };

  if (!responsedata) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "24%",
          marginTop: "20%",
        }}
      >
        <CircularProgress disableShrink />
      </div>
    );
  }

  let totalTDS =
    parseFloat(responsedata?.tdsBillOfSupplyDeduction) +
    parseFloat(responsedata?.tdsTaxInvoiceDeduction);

  

  const amount = responsedata?.amount;
  const totalDiffAmount =
    parseFloat(responsedata?.cashfreeAmountReceived || 0) +
    parseFloat(responsedata?.tdsBillOfSupplyDeduction || 0) +
    parseFloat(responsedata?.tdsTaxInvoiceDeduction || 0);
  const totalDiffOfline = parseFloat(responsedata?.offlineBillDetails?.amountReceivedAgainstBill || 0) + parseFloat(responsedata?.offlineBillDetails?.TDSAmount || 0);
  const finalDifAmount = totalDiffAmount ? totalDiffAmount : totalDiffOfline; 
  const amountPending = amount - finalDifAmount;

  const formattedDate = new Date(responsedata?.billingDate)
    .toISOString()
    .split("T")[0]
    .replace(/-/g, "/");

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        margin={3}
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          padding: "20px",
        }}
      >
        <Grid item xs={12}>
          <div style={{ display: "flex", width: "70px", marginBottom: "20px" }}>
            <a
              onClick={handleBack}
              style={{ cursor: "pointer", textDecoration: "none" }}
            >
              <div
                style={{ display: "flex", alignItems: "center", color: "#555" }}
              >
                <ArrowBackIos fontSize="small" />
                <span style={{ marginLeft: "8px" }}>Back</span>
              </div>
            </a>
          </div>
        </Grid>
        <DialogContent>
          <Grid container spacing={4}>
            <Grid item xs={6}>
              <Typography
                variant="h5"
                style={{
                  fontWeight: 600,
                  color: "#333",
                  marginBottom: "16px",
                  borderBottom: "2px solid #4caf50",
                  paddingBottom: "8px",
                  display: "inline-block",
                }}
              >
                Bill Information
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  {/* <Typography
                    variant="subtitle1"
                    sx={{ color: "#666", fontWeight: 500, mb: 1.5 }}
                  >
                    Bill Information
                  </Typography> */}
                </Grid>

                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    // sx={{ py: 1 }}
                  >
                    <Typography variant="body2" sx={{ color: "#757575" }}>
                      Billing Cycle
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {responsedata?.branch?.billingInfo?.billingCycle}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    // sx={{ py: 1 }}
                  >
                    <Typography variant="body2" sx={{ color: "#757575" }}>
                      Bill Generation Date
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {formattedDate}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    // sx={{ py: 1 }}
                  >
                    <Typography variant="body2" sx={{ color: "#757575" }}>
                      Payment Due Date
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {responsedata?.branch?.billingInfo?.paymentDuePeriodDays}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    // sx={{ py: 1 }}
                  >
                    <Typography variant="body2" sx={{ color: "#757575" }}>
                      Payment Due Date (Buffer Days)
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {responsedata?.branch?.billingInfo?.bufferDays}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    // sx={{ py: 1 }}
                  >
                    <Typography variant="body2" sx={{ color: "#757575" }}>
                      Mode of Payment
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {responsedata?.branch?.billingInfo?.billingMode}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Typography
                variant="h5"
                style={{
                  fontWeight: 600,
                  color: "#333",
                  marginBottom: "16px",
                  borderBottom: "2px solid #4caf50",
                  paddingBottom: "8px",
                  display: "inline-block",
                }}
              >
                Financial Snapshot
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  {/* <Typography
                    variant="subtitle1"
                    style={{
                      color: "#666",
                      fontWeight: 500,
                      marginBottom: "12px",
                    }}
                  >
                    Monthly
                  </Typography> */}
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2" style={{ color: "#757575" }}>
                    Amount
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    variant="body2"
                    style={{
                      fontWeight: 500,
                      textAlign: "right",
                      color: "#4caf50",
                    }}
                  >
                    ₹
                    {responsedata?.amount?.toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2" style={{ color: "#757575" }}>
                    Amount Received
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    variant="body2"
                    style={{
                      fontWeight: 500,
                      textAlign: "right",
                      color: "#4caf50",
                    }}
                  >
                    ₹
                    {parseFloat(
                      responsedata?.cashfreeAmountReceived
                        ? responsedata?.cashfreeAmountReceived
                        : responsedata?.offlineBillDetails
                            ?.amountReceivedAgainstBill
                        ? responsedata?.offlineBillDetails
                            ?.amountReceivedAgainstBill
                        : 0
                    ).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2" style={{ color: "#757575" }}>
                    Amount Remaining
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    variant="body2"
                    style={{
                      fontWeight: 500,
                      textAlign: "right",
                      color: "#4caf50",
                    }}
                  >
                    ₹
                    {parseFloat(amountPending).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2" style={{ color: "#757575" }}>
                    TDS Amount Received/Claimed
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    variant="body2"
                    style={{
                      fontWeight: 500,
                      textAlign: "right",
                      color: "#4caf50",
                    }}
                  >
                    ₹
                    {parseFloat(
                      totalTDS
                        ? totalTDS
                        : responsedata?.offlineBillDetails?.TDSAmount
                        ? responsedata?.offlineBillDetails?.TDSAmount
                        : 0
                    ).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} style={{ marginTop: "24px" }}>
              {/* <Button
                variant="contained"
                style={{
                  marginRight: "12px",
                  backgroundColor: "#9e9e9e",
                  color: "#fff",
                  padding: "8px 16px",
                  borderRadius: "4px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                }}
              >
                Add Adjusted Credit Note
              </Button>
              <Button
                variant="contained"
                style={{
                  marginRight: "12px",
                  backgroundColor: "#1976d2",
                  color: "#fff",
                  padding: "8px 16px",
                  borderRadius: "4px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                }}
              >
                Add Adjusted Bill of Supply
              </Button>
              <Button
                variant="contained"
                style={{
                  marginRight: "12px",
                  backgroundColor: "#4caf50",
                  color: "#fff",
                  padding: "8px 16px",
                  borderRadius: "4px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                }}
              >
                Approve Payment
              </Button>
              <Button
                variant="contained"
                style={{
                  marginRight: "12px",
                  backgroundColor: "#f44336",
                  color: "#fff",
                  padding: "8px 16px",
                  borderRadius: "4px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                }}
              >
                Reject Payment
              </Button> */}
              <Button
                variant="contained"
                style={{
                  marginRight: "12px",
                  backgroundColor: "#4A4A4A",
                  color: "#fff",
                  padding: "8px 16px",
                  borderRadius: "4px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  transition: "background-color 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#3A3A3A";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#4A4A4A";
                }}
                onClick={handleOpen}
              >
                Transaction History
              </Button>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#A100FF",
                  color: "#fff",
                  padding: "8px 16px",
                  borderRadius: "4px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  transition: "background-color 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#8000CC";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#A100FF";
                }}
                onClick={handleOpenPayment}
                disabled={parseFloat(responsedata?.cashfreeAmountReceived) > 0}
              >
                Add Offline Payment
              </Button>

              <TransactionHistory
                billNumber={responsedata?.billNumber}
                open={open}
                handleClose={handleClose}
                billData={responsedata}
              />

              <AddPayment
                billId={responsedata?._id}
                billNumber={responsedata?.billNumber}
                totalAmount={responsedata?.amount}
                billData={responsedata}
                open={openPayment}
                handleClosePayment={handleClosePayment}
              />
            </Grid>
          </Grid>
        </DialogContent>
      </MDBox>
    </DashboardLayout>
  );
};

export default BillDetails;
